interface SwapViewColumnParams<TColumn> {
    fromColumnId: string;
    toColumnId: string;
    createTargetColumn: (sourceColumn: TColumn) => TColumn;
}

/**
 * Replaces the column identified by `fromColumnId` with one produced by
 * `createTargetColumn`, preserving the original column order. If a column with
 * `toColumnId` already exists, the `fromColumnId` column is dropped instead so
 * the target column is never duplicated.
 *
 * Shared by view configs that swap the Category and Cash-ledger columns based
 * on a workspace's GL-first setting, where the source column may come from a
 * previously cached view.
 */
export const swapViewColumn = <TColumn extends { id: string }>(
    columns: TColumn[],
    {
        fromColumnId,
        toColumnId,
        createTargetColumn,
    }: SwapViewColumnParams<TColumn>,
): TColumn[] => {
    const hasTargetColumn = columns.some((column) => column.id === toColumnId);

    return columns.flatMap((column) => {
        if (column.id !== fromColumnId) {
            return [column];
        }
        return hasTargetColumn ? [] : [createTargetColumn(column)];
    });
};
